import React, { useState } from 'react'
import { Modal, Button, Alert } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import fileDownload from 'js-file-download'
import PdfViewer from '../../../../../../../../components/common/PdfViewer/PdfViewer'

const AttachmentPreviewModal = ({ open, onClose, kind, objectUrl, blob, name }) => {
    const [imageError, setImageError] = useState(false)

    const handleDownload = () => {
        if (blob) fileDownload(blob, name)
    }

    const footer = (
        <Button icon={<DownloadOutlined />} onClick={handleDownload}>
            Download
        </Button>
    )

    return (
        <Modal
            open={open}
            onCancel={onClose}
            title={name}
            width={900}
            footer={footer}
            styles={{ body: { maxHeight: '75vh', overflowY: 'auto', padding: kind === 'pdf' ? 0 : undefined } }}
            destroyOnHidden
            afterClose={() => setImageError(false)}
        >
            {kind === 'image' && !imageError && (
                <img
                    src={objectUrl}
                    alt={name}
                    style={{ maxWidth: '100%', display: 'block', margin: '0 auto' }}
                    onError={() => setImageError(true)}
                />
            )}
            {kind === 'image' && imageError && (
                <Alert
                    message='Could not display image'
                    description='The file could not be rendered. You can still download it.'
                    type='error'
                    showIcon
                />
            )}
            {kind === 'pdf' && (
                <PdfViewer file={objectUrl} />
            )}
        </Modal>
    )
}

export default AttachmentPreviewModal
